import { STEPS } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function ProcessPage() {
  return (
    <section className="page" data-testid="page-process">
      <div className="grain" />
      <Corner section="V · Process" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Our Process</div>
          <h2 className="h-title">
            How we power<br />your <em>rooftop.</em>
          </h2>
        </div>

        <p className="body" style={{ maxWidth: "65%" }}>
          From the first phone call to the day your meter starts spinning backwards — every step is owned and delivered by INPACE POWER. No sub-contracting. No surprises.
        </p>

        <div className="process-grid">
          {STEPS.map((s) => (
            <div className="process-step" key={s.n}>
              <div className="step-num">{s.n}</div>
              <div>
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 32, padding: "20px 24px", border: "1px solid var(--line-2)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 18 }}>
          <div>
            <div className="eyebrow">Average Timeline</div>
            <p className="body" style={{ margin: "8px 0 0" }}>
              Survey → Design → Installation → Commissioning · <strong>7–21 working days</strong>
            </p>
          </div>
          <div className="stat-num" style={{ fontSize: 56 }}>
            07<span className="plus" style={{ fontSize: 22, marginLeft: 4 }}>days</span>
          </div>
        </div>
      </div>
      <PageFooter num="12" />
    </section>
  );
}
